import {Result} from 'antd';
import React from 'react';
import {Link} from 'react-router-dom';

const Unauthorized: React.FC = () => {
  return (
    <div>
      <Result
        status="warning"
        title="您无权访问此页面"
        extra={
          <Link to="/">
            回到首页
          </Link>
        }
      />
    </div>
  );
};

export default Unauthorized;